import "core-js/modules/es6.regexp.replace.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import axios from 'axios';
import DOMPurify from 'dompurify';
export default {
  name: 'FibSvg',
  props: {
    color: {
      type: String,
      default: ''
    },
    strokeColor: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: 'initial'
    },
    margin: {
      type: String,
      default: 'initial'
    },
    maxHeight: {
      type: String,
      default: '100%'
    },
    maxWidth: {
      type: String,
      default: '100%'
    },
    padding: {
      type: String,
      default: 'initial'
    },
    src: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: 'initial'
    }
  },
  data: function data() {
    return {
      svg: null
    };
  },
  computed: {
    styleColor: function styleColor() {
      if (this.color) {
        return this.color;
      }

      return '';
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.src) {
      var url = this.src.replace('@', window.location.origin);

      if (url) {
        axios.get(url).then(function (res) {
          if (res && res.data) {
            var sanitized = DOMPurify.sanitize(res.data);
            _this.svg = sanitized;
          }
        });
      }
    }
  }
};